import { promiseFetchDataAuth } from "crk-front-lib/services/promise-fetch";
import React, { useState, useContext, useEffect, createContext } from "react";

/** For more details on
 * `authContext`, `ProvideAuth`, `useAuth` and `useProvideAuth`
 * refer to: https://usehooks.com/useAuth/
 */

function initFromStorage() {
  const token = localStorage.getItem('access_token');
  const user_id = localStorage.getItem('user_id');
  const username = localStorage.getItem('username');
  const fullname = localStorage.getItem('fullname');
  const pkg_id = localStorage.getItem('pkg_id');
  const pkg_age = localStorage.getItem('pkg_age');
  const pkg_expire = localStorage.getItem('pkg_expire');
  const pkg_payer = localStorage.getItem('pkg_payer');
  const member_role = localStorage.getItem('member_role');
  const org_id = localStorage.getItem('org_id');
  
  if(token && username) {
    return {
      user_id,
      username,
      fullname,
      pkg_id,
      pkg_age,
      pkg_expire,
      pkg_payer,
      member_role,
      org_id,
    }
  }
  
  return null;
}

const authContext = createContext();

export function ProvideAuth({ children }) {
  const auth = useProvideAuth();

  return (
    <authContext.Provider value={auth}>
      {children}
    </authContext.Provider>
  );
}

// Hook for child components to get the auth object ...
// ... and re-render when it changes.
export const useAuth = () => {
  return useContext(authContext);
};

// Provider hook that creates auth object and handles state
function useProvideAuth() {
  const [user, setUser] = useState(initFromStorage());
  const [lang, setLang] = useState('en');
  const [config, setConfig] = useState({})

  useEffect(() => {
    console.info('Load config.json by use-auth => useProvideAuth');
    fetch('/js/config.json')
    .then(res => res.json())
    .then(json => setConfig(json))
    .catch(err => {
      console.error(err);
    })
  }, [])

  useEffect(() => {
    const org_id = localStorage.getItem('org_id')
    if (config.storeApi && config.storeApi !== '' && org_id) {
      console.info('Refresh Token...');
      promiseFetchDataAuth(`${config.storeApi}/api/v2/refresh-token`, 'POST', {
        app_id: config.appId,
        org_id: org_id,
      })
      .then(result => {
        // console.info(result);
        if (result.token) {
          localStorage.setItem('access_token', result.token);
        }
      })
      .catch(err => {
        console.warn(err);
      })
    }
  }, [config])

  const signin = (data) => {
    setUser(data);
  }

  const signup = () => {}

  const signout = () => {
    setUser(null);
    localStorage.clear();
  }

  return {
    user,
    signin,
    signup,
    signout,

    lang,
    setLang,

    config,
  };
}
